/**
 * The vocabulary the template designer's "Mark slots for me" uses.
 *
 * Split out from app.js so it can be tested: every name here is fed straight to
 * utils/templateCompile.js, which rejects names that are malformed or reserved.
 * A bad entry would only surface as a save failure the teacher can't explain,
 * so the test asserts the whole vocabulary is compiler-valid.
 *
 * Class rules come first – they carry intent the tag alone doesn't ("this <div>
 * is the left column's heading"). Tag rules are the fallback.
 */
(function (root, factory) {
    if (typeof module === 'object' && module.exports) module.exports = factory();
    else root.SlotGuess = factory();
}(typeof self !== 'undefined' ? self : this, function () {
    'use strict';

    const BY_CLASS = [
        { match: '.slide__heading',     name: 'heading',     type: 'short_text', hint: 'The slide title' },
        { match: '.slide__subtitle',    name: 'subtitle',    type: 'short_text', hint: 'A short supporting line under the title' },
        { match: '.slide__col-heading', name: 'col_heading', type: 'short_text', hint: 'The heading for this column' },
        { match: '.slide__bullets',     name: 'bullets',     type: 'bullets',    hint: 'The main points of the slide' },
        { match: '.slide__col-bullets', name: 'col_points',  type: 'bullets',    hint: 'The points in this column' },
        { match: '.slide__body',        name: 'body',        type: 'paragraph',  hint: 'A short explanatory paragraph' },
        { match: '.slide__quote-text',  name: 'quote_text',  type: 'paragraph',  hint: 'The quote itself' },
        { match: '.slide__term',        name: 'term',        type: 'short_text', hint: 'The key term being defined' },
        { match: '.slide__definition',  name: 'definition',  type: 'paragraph',  hint: 'The formal definition of the term' },
    ];

    const BY_TAG = {
        img: { name: 'picture', type: 'image',      hint: 'A supporting picture' },
        ul:  { name: 'points',  type: 'bullets',    hint: 'A list of points' },
        ol:  { name: 'points',  type: 'bullets',    hint: 'A list of points' },
        p:   { name: 'body',    type: 'paragraph',  hint: 'A short paragraph' },
        h1:  { name: 'heading', type: 'short_text', hint: 'A heading' },
        h2:  { name: 'heading', type: 'short_text', hint: 'A heading' },
        h3:  { name: 'heading', type: 'short_text', hint: 'A heading' },
        h4:  { name: 'heading', type: 'short_text', hint: 'A heading' },
    };

    const FALLBACK = { name: 'text', type: 'short_text', hint: 'A short line of text' };

    /** @param {Element} el @returns {{name,type,hint}} */
    function forElement(el) {
        for (const rule of BY_CLASS) {
            if (el.matches(rule.match)) return { name: rule.name, type: rule.type, hint: rule.hint };
        }
        return { ...(BY_TAG[el.tagName.toLowerCase()] || FALLBACK) };
    }

    /** Every name/type pair the guesser can ever emit – used by its test. */
    function vocabulary() {
        return [
            ...BY_CLASS.map(r => ({ name: r.name, type: r.type })),
            ...Object.values(BY_TAG).map(r => ({ name: r.name, type: r.type })),
            { name: FALLBACK.name, type: FALLBACK.type },
        ];
    }

    return { forElement, vocabulary, BY_CLASS, BY_TAG, FALLBACK };
}));
